
import { AuthService } from '@core/services/auth';





import { inject, Injectable } from '@angular/core';
import { HttpErrorResponse, HttpEvent, HttpHandlerFn, HttpInterceptorFn, HttpRequest, HttpResponse } from '@angular/common/http';
import { catchError, Observable, switchMap, tap, throwError } from 'rxjs';
import { ApiResponseService } from '@core/services/api-response.service';


export const authInterceptor: HttpInterceptorFn = (req: HttpRequest<any>, next: HttpHandlerFn) => {
  const auth = inject(AuthService);
  const apiResponse = inject(ApiResponseService);
  const token = auth.getAccessToken();

  // 🛡️ Skip certain URLs or already handled requests if needed
  // Clone request and add token if available
  let clonedReq = req;
  if (token) {
    clonedReq = req.clone({
      setHeaders: { Authorization: `Bearer ${token}` },
    });
  }

  return next(clonedReq).pipe(
    tap((event: HttpEvent<any>) => {
      // ✅ Handle success messages through shared service
      apiResponse.handleSuccess(event, req);
    }),
    catchError((error: HttpErrorResponse): Observable<HttpEvent<any>> => {
      // 🧠 Handle 401 → try refresh
      const isLoginRequest = req.url.includes('login');
      const isRefreshRequest = req.url.includes('refresh') || req.url.includes('token/refresh');

      if (error.status === 401) {
        // If it's a refresh token call that fails with 401, we MUST logout
        if (isRefreshRequest) {
          auth.logout();
          return throwError(() => error);
        }
        
        // Try to refresh if it's NOT a login request
        if (!isLoginRequest) {
          return auth.handle401Error(clonedReq, next);
        }
      }

      // 🕸️ Handle messages through shared service
      apiResponse.handleError(error);

      return throwError(() => error);
    })
  );
};